export default "__VITE_PUBLIC_ASSET__69a4e213__"